var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.5547,
    cy: 24.5098,
    rx: 25,
    ry: 24.5098,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5539 13C21.4352 13 18.0977 16.3562 18.0977 20.5C18.0977 27.6625 25.5539 37 25.5539 37C25.5539 37 33.0102 27.6625 33.0102 20.5C33.0102 16.3562 29.6727 13 25.5539 13ZM25.5539 24.1375C23.6039 24.1375 22.0289 22.55 22.0289 20.5938C22.0289 18.6375 23.6102 17.0437 25.5539 17.0437C27.5039 17.0437 29.0789 18.6312 29.0789 20.5938C29.0789 22.55 27.5039 24.1375 25.5539 24.1375Z",
    fill: "#7A53FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.b2ffb75483b07e21739f6bd78f6951cc.svg";
export { ForwardRef as ReactComponent };